import React, { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import Gallery from './components/Gallery';
import Footer from './components/Footer';
import QuoteModal from './components/QuoteModal';

function App() {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  const openQuoteModal = (e) => {
    if (e) e.preventDefault();
    setIsQuoteModalOpen(true);
  };

  const closeQuoteModal = () => {
    setIsQuoteModalOpen(false);
  };

  return (
    <div className="min-h-screen bg-surface">
      <Navbar onOpenQuote={openQuoteModal} />
      <Hero onOpenQuote={openQuoteModal} />
      <Services />
      {/* "Our Sample Work" moved here before Portfolio */}
      <Gallery /> 
      <Portfolio />
      <Testimonials />
      <Footer />
      
      {/* High-end aesthetic modal for Deftform */}
      <QuoteModal isOpen={isQuoteModalOpen} onClose={closeQuoteModal} />
    </div>
  );
}

export default App;